module.exports = __webpack_public_path__ + "static/media/call-now.e947a4cb.svg";